
	{
	  "apiUrl": "../_api/rest",
	  "title": "Cohelion | De IJsmaker",
	  "supportEmail": "vraag@deijsmaker.nl",
	  "customerName": "De IJsmaker",
	  "dsnSentry": "https://a0b8dcb75cff459f869b829477fced57@errors.cohelion.com/47",
	  "translationLocation": "/client/assets/i18n",
	  "googleMapsApiKey": "AIzaSyBA2TUkcIjk8ZAXembREE9OFZRPZHFdbnE",
	  "environment": "Preview",
	  "useMockData": false
	}